import { type GetRefLabelsParams, useGetRefLabels } from "@/networking/api"
import { Orders } from "@/utils/filters/types"
import { excludePropertiesOf, isBlank } from "@/utils/ts-utils"
import { useMemo } from "react"

const STALE_TIME_FIFTEEN_MINUTES_IN_MS = 15 * 60 * 1000

export default (group: string, filters?: GetRefLabelsParams, options?: Record<string, unknown>) => {
  const params = useMemo(
    () =>
      isBlank(group)
        ? undefined
        : {
            group,
            itemsPerPage: 300,
            "order[order]": Orders.ASC,
            "order[label]": Orders.ASC,
            ...excludePropertiesOf(filters ?? {}, ["group"]),
          },
    [group, filters]
  )

  const result = useGetRefLabels(params, {
    query: { staleTime: STALE_TIME_FIFTEEN_MINUTES_IN_MS, ...(options?.query ?? {}) },
    request: { ...(options?.request ?? {}) },
  })
  const labels = useMemo(() => result?.data?.["hydra:member"] ?? [], [result])

  return { ...result, labels }
}
